export enum SessionStatus {
  PENDING = 'PENDING',
  CONNECTING = 'CONNECTING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED'
}

export enum UserRole {
  DISPATCHER = 'DISPATCHER',
  SUPERVISOR = 'SUPERVISOR',
  ADMIN = 'ADMIN',
  CITIZEN = 'CITIZEN',
  SPECTATOR_AMBULANCE = 'SPECTATOR_AMBULANCE'
}

export enum CameraFacing {
  USER = 'user',
  ENVIRONMENT = 'environment'
}

export const SessionTimeouts = {
  DEFAULT_TOKEN_EXPIRATION_MINUTES: 15,
  MAX_TOKEN_EXPIRATION_MINUTES: 60,
  RECONNECT_TIMEOUT_SECONDS: 30,
  GPS_UPDATE_INTERVAL_MS: 3000,
  PING_INTERVAL_MS: 10000
} as const;

export const EmergencyChannels = {
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  DIRECT_LINK: 'DIRECT_LINK'
} as const;

export type EmergencyChannel = keyof typeof EmergencyChannels;
